import { queryClient } from '../../../../queryClient';
import { queryKeys } from './query-keys';
export var refetchCampaignsListQuery = function () {
    return queryClient.refetchQueries({
        queryKey: queryKeys.allCampaigns(),
        predicate: function (query) {
            var queryKey = query.queryKey;
            // This matches the `campaignsByOwner` query with pagination,
            // so we only reset the listing query, not all campaign related queries
            return (Array.isArray(queryKey) &&
                queryKey[0] === queryKeys.allCampaigns()[0] &&
                queryKey.length >= 3 &&
                typeof queryKey[3] === 'string' &&
                queryKey[3].includes('page:'));
        },
    });
};
